import { useEffect, useState } from "react";
import "./appListing.scss"
import { DragDropContext, Draggable, Droppable, DropResult } from "react-beautiful-dnd";
import { KTSVG, toAbsoluteUrl } from "../../../_metronic/helpers";
import ScreenCard from "../components/screenCard/ScreenCard";
import CreateFlowDialog from "../components/dialog/CreateFlowDialog";
import httpService from "../../../setup/http/httpServices";
import { handleMultiFileUpload } from "../../../setup/Upload/MultiUpload";
import ScreenDetailDialog from "../components/dialog/ScreenDetailDialog";
import axios from "axios";
import { useHistory } from "react-router-dom";

interface CardData {
    id: string;
    content: string;
    image: string;
}

const AddScreens = () => {
    const baseURL = process.env.REACT_APP_API_URL;
    const history: any = useHistory()
    const [createFlowDialogOpen, setCreateFlowDialogOpen] = useState(false);
    const [imageLoading, setImageLoading] = useState<boolean>(false);
    const [screenDetailDialogOpen, setScreenDetailDialogOpen] = useState(false);
    const [elements, setElements] = useState([])
    const [screenCategory, setScreenCategory] = useState([])
    const [flowCategory, setFlowCategory] = useState([])
    const [associatedTags, setAssociatedTags] = useState([])
    const [selectedScreens, setSelectedScreens] = useState<string[]>([]);
    const [allScreen, setAllScreen] = useState([])
    const [screenId, setScreenId] = useState('')

    const app_id = history.location.state?.edit ? history.location.state?.appListing?._id : history.location.state?.app_id;

    // console.log('screen app_id', history.location.state?.app_id)

    // console.log('appListing', history.location.state?.appListing?.screens)
    // console.log('allScreen', allScreen)
    // console.log('basic', history.location.state?.basicDetail?._id)
    // console.log('screen edit', history.location.state?.edit)

    useEffect(() => {
        if (history.location.state?.edit) {
            setAllScreen(history.location.state?.appListing?.screens)
        }
    }, [])


    // Screen  Popup
    const handleOpenScreenDetailDialog = (screenId: string) => {
        setScreenDetailDialogOpen(true);
        // Fetch screen details using the screenId
        setScreenId(screenId);
    };
    const handleCloseScreenDetailDialog = () => {
        setScreenDetailDialogOpen(false);
    };

    // Flow  Popup
    const handleOpenCreateFlowDialog = () => {
        setCreateFlowDialogOpen(true);
    };
    const handleCloseCreateFlowDialog = () => {
        setCreateFlowDialogOpen(false);
    };




    const handleScreenSelect = (id: string) => {
        setSelectedScreens(prevSelectedScreens => {
            const isSelected = prevSelectedScreens.includes(id);
            if (isSelected) {
                // If the screen is already selected, deselect it
                return prevSelectedScreens.filter(screenId => screenId !== id);
            } else {
                // If the screen is not selected, select it
                return [...prevSelectedScreens, id];
            }
        });
    };





    // const onDragEnd = (result: DropResult) => {
    //     if (!result.destination) return;

    //     const newCards = Array.from(allScreen);
    //     const [reorderedCard] = newCards.splice(result.source.index, 1);
    //     newCards.splice(result.destination.index, 0, reorderedCard);

    //     setAllScreen(newCards);
    // };

    const onDragEnd = async (result: DropResult) => {
        if (!result.destination) return;

        const newCards = Array.from(allScreen);
        const [reorderedCard] = newCards.splice(result.source.index, 1);
        newCards.splice(result.destination.index, 0, reorderedCard);

        setAllScreen(newCards);

        // Assuming you have an API function to send screen position updates
        try {
            await updateScreenPosition(reorderedCard._id, result.destination.index + 1);
            console.log('Screen position updated successfully!');
        } catch (error) {
            console.error('Error updating screen position:', error);
        }
    };

    const updateScreenPosition = async (screenId: string, newPosition: number) => {
        axios.patch(
            `${baseURL}/app/screen-position`,
            {
                headers: httpService.serviceHeader,

                appId: app_id,
                screenId: screenId,
                newPosition: newPosition,

            }
        ).then((res) => {
            console.log('updated position screen', res);
            fetchAllScreens();
        }).catch((error) => {
            console.error('Error deleting screens:', error);
        });

    };




    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        // const app_id = history.location.state?.appListing?._id;
        if (files && files.length > 0) {
            setImageLoading(true);
            try {
                const urls = await handleMultiFileUpload(files, undefined, undefined, app_id, setImageLoading);
                if (urls) {
                    fetchAllScreens();
                }
                // console.log('Uploaded file URLs:', urls);
            } catch (error) {
                console.error('Error uploading files:', error);
            }
        }
    };

    // Delete Screen Handler
    const deleteScreenHandler = () => {
        if (selectedScreens.length > 0) {
            axios.delete(
                `${baseURL}/app-screen/delete-screens`,
                {
                    headers: httpService.serviceHeader,
                    data: { ids: selectedScreens }
                }
            ).then((res) => {
                // console.log('delete screen by id', res);
                fetchAllScreens();
            }).catch((error) => {
                console.error('Error deleting screens:', error);
            });
        }
    };

    // Fetch all screens
    const fetchAllScreens = () => {
        httpService.getData(
            `/app/screens/${app_id}`,
            (res) => {
                setAllScreen(res.data?.data);
            },
            (err) => {
                console.log('err', err);
            }
        );
    };



    //  GET ALL SCREEN 
    useEffect(() => {
        if (imageLoading === true) {
            fetchAllScreens();
        }
    }, [imageLoading]);





    //  GET ALL SCREEN CATEGORY
    useEffect(() => {
        httpService.getData(
            '/screenCategory-master',
            (res) => {
                setScreenCategory(res.data.data.data)
            },
            (err) => {
                console.log('err', err)
            }
        )
    }, []);

    //  GET ALL FLOW CATEGORY
    useEffect(() => {
        httpService.getData(
            '/flowCategory-master',
            (res) => {
                setFlowCategory(res.data.data.data)
            },
            (err) => {
                console.log('err', err)
            }
        )
    }, []);

    //  GET ALL UI ELEMENTS
    useEffect(() => {
        httpService.getData(
            '/element-master?limit=20&page=1&search=&sort=Name',
            (res) => {
                setElements(res.data.data.data)
            },
            (err) => {
                console.log('err', err)
            }
        )
    }, []);

    //  GET ALL TAGS
    useEffect(() => {
        httpService.getData(
            '/tag-master?limit=20&page=1&search=&sort=Name',
            (res) => {
                setAssociatedTags(res.data.data.data)
            },
            (err) => {
                // console.log('err', err)
            }
        )
    }, []);






    // Function to handle creation of flow with selected screens
    const handleCreateFlow = () => {
        if (selectedScreens.length > 0) {
            // console.log("Creating flow with screens IDs:", selectedScreens);
            setCreateFlowDialogOpen(true); // Close dialog after creating flow
        }
    };

    const resetSelectedScreen = () => {
        setSelectedScreens([])
    }



    return (
        <>
            <div className="sreeen-header">
                <div className="left-box">
                    <h4>{allScreen?.length} Screens Added</h4>
                    <div className="add-box">
                        <label htmlFor="file-input" className="add-btn">
                            <KTSVG path={toAbsoluteUrl('/media/icons/Custom/Add.svg')} />
                        </label>
                        <input type="file" multiple id="file-input" className="file-input" onChange={handleFileChange} />
                    </div>
                </div>
                <div className="right-box">
                    <button
                        type='button'
                        id='kt_sign_up_submit'
                        className='btn btn-primary'
                        onClick={handleCreateFlow}
                        disabled={selectedScreens.length === 0 ? true : false}
                    >
                        <span className='indicator-label'>Create Flow</span>

                    </button>
                    <button
                        type='button'
                        id='kt_sign_up_submit'
                        className='btn deleteBtn'
                        onClick={deleteScreenHandler}
                    >
                        <img
                            className='cursor-pointer'
                            src={toAbsoluteUrl('/media/icons/Custom/Dustbin.svg')}
                            style={{ marginBottom: '0', marginRight: '8px', marginLeft: '5%' }}
                            alt='delete'
                        />
                        <span className='indicator-label'>Delete</span>

                    </button>
                    <div className="line"></div>
                    <button
                        type='submit'
                        id='kt_sign_up_submit'
                        className='btn btn-primary'
                        onClick={() => {
                            history.push({
                                pathname: '/mobile-application/flow',
                                state: {
                                    ...history.location.state,
                                },
                            })
                        }}
                    >
                        <span className='indicator-label'>Save Changes</span>

                    </button>
                </div>

            </div>
            <div className="add-screens-container">
                {allScreen?.length === 0 && <h2 style={{ textAlign: "center", marginTop: "3rem" }}>No Screens Added</h2>}
                {imageLoading && (
                    <div className='loader'>
                        <span className='svg-icon svg-icon-5x flex svg-icon-primary me-3 ms-8'>
                            <KTSVG path={toAbsoluteUrl('/media/icons/Custom/Loading.svg')} />
                        </span>
                    </div>
                )}
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="cards" direction="horizontal">
                        {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef} className="screens-container">
                                {allScreen?.map((card, index) => (
                                    <Draggable key={card._id} draggableId={card._id} index={index}>
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                <ScreenCard
                                                    id={card._id}
                                                    img={card.image}
                                                    onClick={() => handleOpenScreenDetailDialog(card._id)}
                                                    onSelect={() => handleScreenSelect(card._id)}
                                                    isSelected={selectedScreens.includes(card._id)}
                                                />
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>

            </div>

            <ScreenDetailDialog open={screenDetailDialogOpen}
                onClose={handleCloseScreenDetailDialog}
                elements={elements}
                screenCategory={screenCategory}
                associatedTags={associatedTags}
                screenId={screenId}
                deleteHandler={deleteScreenHandler}
            />

            <CreateFlowDialog
                open={createFlowDialogOpen}
                onClose={handleCloseCreateFlowDialog}
                selectedScreen={selectedScreens}
                flowCategory={flowCategory}
                resetSelectedScreen={resetSelectedScreen}
            />

        </>

    )
}

export default AddScreens